import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import amlogo from '../assets/coplaid-logo-transparent.png';
import { APP_URL } from '../config';
import './Header.css';

const Header = () => {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 900);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const onResize = () => {
      setIsMobile(window.innerWidth <= 900);
      if (window.innerWidth > 900) setIsMenuOpen(false);
    };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const go = (path) => {
    navigate(path);
    setIsMenuOpen(false);
  };

  const goLogin = () => { window.location.href = `${APP_URL}/login`; };

  return (
    <header className="cp-header">
      <div className="cp-header-inner">
        <div className="cp-header-logo" onClick={() => go('/')}>
          <img src={amlogo} alt="CoPlaid" />
        </div>

        {!isMobile && (
          <>
            <nav className="cp-nav" aria-label="Primary">
              <button className="cp-nav-item" onClick={() => go('/product')}>Product</button>
              <button className="cp-nav-item" onClick={() => go('/partners')}>Partners</button>
              <button className="cp-nav-item" onClick={() => go('/ship')}>Ship</button>
              <button className="cp-nav-item" onClick={() => go('/contact')}>Contact</button>
            </nav>

            <div className="cp-header-auth">
              <button className="cp-btn cp-btn--ghost cp-btn--sm" onClick={goLogin}>Sign in</button>
              <button className="cp-btn cp-btn--primary cp-btn--sm" onClick={() => go('/contact')}>Talk to us</button>
            </div>
          </>
        )}

        {isMobile && (
          <button
            className="cp-header-burger"
            onClick={() => setIsMenuOpen((v) => !v)}
            aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
          >
            {isMenuOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
        )}
      </div>

      {isMobile && isMenuOpen && (
        <div className="cp-mobile-menu">
          <button className="cp-mobile-link" onClick={() => go('/product')}>Product</button>
          <button className="cp-mobile-link" onClick={() => go('/partners')}>Partners</button>
          <button className="cp-mobile-link" onClick={() => go('/ship')}>Ship</button>
          <button className="cp-mobile-link" onClick={() => go('/contact')}>Contact</button>
          <div className="cp-mobile-actions">
            <button className="cp-btn cp-btn--ghost" onClick={goLogin}>Sign in</button>
            <button className="cp-btn cp-btn--primary" onClick={() => go('/contact')}>Talk to us</button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
